import React from 'react';
import { gridSpacing } from 'store/constant';
import { useTheme } from '@mui/material/styles';
import { connect } from 'react-redux';
import { Grid, Toolbar, AppBar } from '@mui/material';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import './styleSearch.scss';
import CampaignAutocompleteDropDown from './CampaignAutocompleteDropDown';
import DateSelector from './DateSelector';
import ApplyFilterPage from './ApplyFilterPage';

const SearchBarGTV = () => {
  const theme = useTheme();

  return (
    <AppBar
      enableColorOnDark
      position="static"
      color="inherit"
      elevation={0}
      sx={{ bgcolor: theme.palette.background.default }}
    >
      <Toolbar style={{ width: '100%' }}>
        <Grid container spacing={gridSpacing}>
          <Grid item lg={6} md={12} sm={6} xs={12}>
            <CampaignAutocompleteDropDown />
          </Grid>
          <Grid item lg={3} md={6} sm={3} xs={6}>
            <DateSelector />
          </Grid>
          <Grid item lg={1.5} md={2} sm={2} xs={6}>
            <ApplyFilterPage />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default SearchBarGTV;
